import i18n from '@/services/i18n'

const { t } = i18n

export const enum PermissionKeysEnum {
  MANAGEMENT_VAULT_TRADE_POLICY = 'MANAGEMENT_VAULT_TRADE_POLICY', // 管理钱包交易策略
  MANAGEMENT_VAULT_USER = 'MANAGEMENT_VAULT_USER', // 管理钱包成员
  MANAGEMENT_VAULT_API_KEY = 'MANAGEMENT_VAULT_API_KEY', // 管理api key
  MANAGEMENT_VAULT_ADDRESS = 'MANAGEMENT_VAULT_ADDRESS', // 管理地址簿
  MANAGEMENT_VAULT_ASSETS = 'MANAGEMENT_VAULT_ASSETS', // 管理钱包账户
  MANAGEMENT_CRYPTO_FUND = 'MANAGEMENT_CRYPTO_FUND', // 管理 token fund
  QUERY_RECEIVE_ADDRESS = 'QUERY_RECEIVE_ADDRESS', // 查看接收地址
  CREATE_TRADE = 'CREATE_TRADE', // app发起交易，限于app透出的账户
  ALL_READ = 'ALL_READ', // 所有读取权限
  AUDIT_TRADE = 'AUDIT_TRADE', // 审批交易
  // 以下两个权限客户端用不上，先不管
  CREATE_TRADE_OF_API_CREATE_ASSETS = 'CREATE_TRADE_OF_API_CREATE_ASSETS', // 发起交易，限于api创建的钱包账户
  CREATE_TRADE_OF_USER_CREATE_ASSETS = 'CREATE_TRADE_OF_USER_CREATE_ASSETS', // 发起交易，限于平台创建的钱包账户
}

export enum UserRoleEnum {
  OWNER = 1,
  ADMIN = 2,
  MEMBER = 3,
  NONE = -1,
}

export enum DestinationTypeEnum {
  VAULT_ACCOUNT = 'VAULT_ACCOUNT',
  INTERNAL_WALLET = 'INTERNAL_WALLET',
  ONE_TIME_ADDRESS = 'ONE_TIME_ADDRESS',
}

export enum TradeToAccountTypeEnum {
  ANY = 1,
  VAULT_ACCOUNT = 2,
  WHITE_LIST = 3,
  ONE_TIME_ADDRESS = 4,
}

export enum FeeLevelTypeEnum {
  LOW = 'LOW',
  MIDDLE = 'MIDDLE',
  HIGH = 'HIGH',
}

export enum SourceTypeEnum {
  VAULT_ACCOUNT = 'VAULT_ACCOUNT',
}

// 1.注册 2.登录 3.备份私钥分片A 4.备份私钥分片B 5.备份私钥分片C 6.查看私钥分片A 7.查看私钥分片B 8.查看私钥分片C 9.修改策略 10. 审批交易
export enum BusinessType {
  REGISTER = 1,
  LOGIN = 2,
  PRIVATE_KEY_BACKUP_A = 3,
  PRIVATE_KEY_BACKUP_B = 4,
  PRIVATE_KEY_BACKUP_C = 5,
  PRIVATE_KEY_PREVIEW_A = 6,
  PRIVATE_KEY_PREVIEW_B = 7,
  PRIVATE_KEY_PREVIEW_C = 8,
  MODIFY_POLICY = 9,
  APPROVE_TRANSACTIONS = 10,
  ADD_WHITE_ADDRESS = 11,
  DISPLAY_EXTENDED_PUBLIC = 12,
  PRIVATE_KEY_UPGRADE = 13,
  ADD_TRADE_PERMISSION = 14,
  EDIT_WHITE_ADDRESS = 15,
}

export enum SecurityTypeEnum {
  BIOMETRICS = 0,
  WALLET_PASSWORD = 1,
  GA = 2,
  EMAIL = 3,
  NONE = -1,
}

export enum LocalBackupStateEnum {
  WAITING = 1,
  BACKUPING = 2,
  COMPLETE = 3,
  ERROR = 4,
  NONE = 0,
}

export enum Web3TransactionStatusEnum {
  SUBMITTED = 0,
  SIGNING = 10,
  CANCELLED = 1,
  SIGN_COMPLETED = 4,
  FAILED = 5,
  REJECTED = 7,
}

export enum ApprovalFlowTypeEnum {
  SELF = 'NONE', // 自己审批
  RULE = 'RULE', // 设定审批流
}

/**
 * 审批流审核状态
 */
export enum TxAuditStatusEnum {
  NEW = 0, // 待审核 审批中
  PASSED = 1, // 同意
  REFUSED = 2, // 拒绝
}

export const TxAuditStatusMap: { [key in TxAuditStatusEnum]: string } = {
  [TxAuditStatusEnum.NEW]: `${t('policy.pending')}`,
  [TxAuditStatusEnum.PASSED]: `${t('policy.passed')}`,
  [TxAuditStatusEnum.REFUSED]: `${t('policy.reject')}`,
}
export enum WalletPermissionEnum {
  CRYPTO_FUND = 'MANAGEMENT_CRYPTO_FUND',
  TRADE_POLICY = 'MANAGEMENT_VAULT_TRADE_POLICY',
  API_KEY = 'MANAGEMENT_VAULT_API_KEY',
  WHITE_LIST = 'MANAGEMENT_VAULT_ADDRESS',
  WALLET = 'MANAGEMENT_VAULT_ASSETS',
}
export enum PolicyTypeEnum {
  SEND = '1',
  MPC_SIGN = '2',
  WEB3 = '3',
}

export const PolicyTypeMap: { [key in PolicyTypeEnum]: string } = {
  [PolicyTypeEnum.SEND]: t('policy.send'),
  [PolicyTypeEnum.MPC_SIGN]: 'MPC Sign',
  [PolicyTypeEnum.WEB3]: t('policy.web3'),
}
export enum PolicyAuditTypeEnum {
  ADD = 1, // 新提交
  DEL = 2, // 删除
}

/**
 * 策略审批状态
 */
export enum PolicyAuditStateEnum {
  PENDING = 0, // 审批中
  SUCCESS = 1, // 通过
  REJECT = 2, // 拒绝
  INIT = -1, // 未提交
  CANCELLED = 3, // 已取消
}

/**
 * 策略from类型
 */
export enum PolicyFromTypeEnum {
  ANY = 1, // 不限制
  VAULT = 2, // 钱包
}

/**
 * 策略from类型
 */
export enum PolicyToTypeEnum {
  ANY = 1, // 不限制
  VAULT = 2, // 钱包
  WHITE = 3, // 白名单
  UNKNOWN = 4, // 陌生地址
}

/**
 * 策略条件类型
 */
export enum PolicyConditionTypeEnum {
  VALUE_GREATER = 1, // 价值大于
  VALUE_LESS = 2, // 价值小于
  NUMBER_GREATER = 3, // 数量大于
  NUMBER_LESS = 4, // 数量小于
  VALUE_TIME = 5, // 时间累积
}
export const PolicyConditionTypeMap = {
  [PolicyConditionTypeEnum.VALUE_GREATER]: `${t('policy.ValueGreaterThan')}`,
  [PolicyConditionTypeEnum.VALUE_LESS]: `${t('policy.ValueLessThan')}`,
  [PolicyConditionTypeEnum.NUMBER_GREATER]: `${t('policy.NumberGreaterThan')}`,
  [PolicyConditionTypeEnum.NUMBER_LESS]: `${t('policy.NumberLessThan')}`,
}

/**
 * 策略执行动作
 */
export enum PolicyActTypeEnum {
  ALLOW = 1, // 进入审批流
  BLOCK = 2, // 拦截
}
type NumBool = 0 | 1
export interface RuleUserModel {
  userKey: string
  userName: string
  userPortrait: string
  isDeleted: boolean
}
export interface FromAccountModel {
  fromAccountKey: string
  fromAccountName: string
}
export interface ApprovalFlowItemModel {
  userDtoList?: RuleUserModel[]
  userKeyList?: string[]
  name: string
  num: number
  type: ApprovalFlowTypeEnum
}

export interface ToAccountModel {
  toAccountKey: string
  toAccountName: string
  blockchainTypeKey: string
  blockchainTypeName: string
  toAddress: string
}
export interface PolicyItemModel {
  type?: PolicyTypeEnum
  key?: string // 策略ID
  workspaceKey: string // 钱包ID
  initiatorIsAny: NumBool // 发起人是否any
  initiatorKeyList?: string[] // 发起人key列表
  initiatorUserDtoList?: RuleUserModel[] // 发起人列表
  fromType: PolicyFromTypeEnum // from类型
  fromAccountIsAny: NumBool // form账户是否全选
  fromAccountKeyList?: string[] // from账户key列表
  fromAccountDtoList?: FromAccountModel[] // from账户列表
  act: PolicyActTypeEnum // 执行动作
  auditUserRule: ApprovalFlowItemModel[] // 审批流
  auditUserRuleDto?: ApprovalFlowItemModel[]
  toType: PolicyToTypeEnum // to类型
  toAccountIsAny: NumBool // to账户是否全选
  toAccountKeyList?: string[] // to账户key列表
  toAccountDtoList?: ToAccountModel[] // to账户列表
  conditionType: PolicyConditionTypeEnum // 触发条件
  amount: string // 条件金额
  transferNumHour24: string // 条件24小时金额
  coinKey: string
  coinName?: string
  auditStatus?: PolicyAuditStateEnum // 审批状态
  activeStatus?: NumBool // 生效状态
  priority?: number // 优先级
  applyType?: any
  toAddressList?: string[] // to地址
  modifyKey: string
}
export enum ApiKeyModelEnum {
  ALL_READ = 'ALL_READ',
  CREATE_TRADE_OF_API_CREATE_ASSETS = 'CREATE_TRADE_OF_API_CREATE_ASSETS',
  CREATE_TRADE_OF_USER_CREATE_ASSETS = 'CREATE_TRADE_OF_USER_CREATE_ASSETS',
  MANAGEMENT_VAULT_ASSETS = 'MANAGEMENT_VAULT_ASSETS',
  AUDIT_TRADE = 'AUDIT_TRADE',
}
export const ApiKeyModelMap: { [key: string]: string } = {
  [ApiKeyModelEnum.ALL_READ]: `${i18n.t('api.read')}`,
  [ApiKeyModelEnum.CREATE_TRADE_OF_API_CREATE_ASSETS]: `${i18n.t('api.apiSend')}`,
  [ApiKeyModelEnum.CREATE_TRADE_OF_USER_CREATE_ASSETS]: `${i18n.t('api.platformSend')}`,
  [ApiKeyModelEnum.MANAGEMENT_VAULT_ASSETS]: `${i18n.t('api.manageWallet')}`,
  [ApiKeyModelEnum.AUDIT_TRADE]: `${i18n.t('api.approve')}`,
}
export enum ApiOperationStateEnum {
  SUCCESS = 0,
  UPDATE_PENDING = 1,
  DELETE_PENDING = 2,
  PENDING = 3,
  REJECT = 4,
  UPDATE_REJECT = 5,
  DELETE_REJECT = 6,
}
export const ApiOperationStateMap: { [key: string]: string } = {
  [ApiOperationStateEnum.SUCCESS]: `${i18n.t('enum.apiStatus.Approved')}`,
  [ApiOperationStateEnum.REJECT]: `${i18n.t('enum.apiStatus.Unapproved')}`,
  [ApiOperationStateEnum.DELETE_PENDING]: `${i18n.t('enum.apiStatus.DeletionPending')}`,
  [ApiOperationStateEnum.DELETE_REJECT]: `${i18n.t('enum.apiStatus.DeletionUnapproved')}`,
  [ApiOperationStateEnum.UPDATE_PENDING]: `${i18n.t('enum.apiStatus.ChangePending')}`,
  [ApiOperationStateEnum.UPDATE_REJECT]: `${i18n.t('enum.apiStatus.ChangeUnapproved')}`,
  [ApiOperationStateEnum.PENDING]: `${i18n.t('enum.apiStatus.Pending')}`,
}
export enum TxStatusEnum {
  NEW = 'SUBMITTED', // 新创建准备审核
  CANCEL = 'CANCELLED', // 取消发起
  BORADCAST = 'BROADCASTING', // 广播中-(没进块)-收交易的开始.0确认
  CONFIRMING = 'CONFIRMING', // 确认中
  SUCCESS = 'COMPLETED', // 成功-(达到确认数
  FAILED = 'FAILED', // 失败
  REFUSE = 'REJECTED', // 拒绝
  SIGNIMG = 'SIGNING', // 签名中
}
export enum TX_ACCOUNT_TYPE_ENUM {
  INTERNAL_WALLET = 'INTERNAL_WALLET',
  VAULT = 'VAULT_ACCOUNT',
  EXCHANGE = 'EXCHANGE_ACCOUNT',
  UNKNOWN = 'UNKNOWN',
}

export enum ExportStateEnum {
  PROCESSING = 1,
  COMPLETED = 2,
  FAILED = 3,
  EXPIRED = 4,
}
export const ExportStateMap: { [key in string]: string } = {
  [ExportStateEnum.PROCESSING]: `${t('enum.exportStatus.Ongoing')}`,
  [ExportStateEnum.COMPLETED]: `${t('enum.exportStatus.Completed')}`,
  [ExportStateEnum.FAILED]: `${t('enum.exportStatus.Fail')}`,
  [ExportStateEnum.EXPIRED]: `${t('enum.exportStatus.Expired')}`,
}
export enum AutoSweepAuditStatus {
  NOSUBMITTED = -1, // 待提交
  INAPPRVAL = 0, // 待审核
  PASSED = 1, // 已通过
  REJECT = 2, // 拒绝
  CANCELLED = 3, // 取消
}
export enum coinTypeEnum {
  MASTER = 'MASTER',
  TOKEN = 'TOKEN',
}
export enum WhiteListAuditStatus {
  NOSUBMITTED = -1, // 待提交
  INAPPRVAL = 0, // 待审核
  PASSED = 1, // 已通过
  REJECT = 2, // 拒绝
  CANCELLED = 3, // 取消
  MODIFIY = 4, // 修改中
}
